import { render } from "./UsersView.vue?vue&type=template&id=6080da04&scoped=true&ts=true"
import script from "./index?vue&type=script&lang=ts"
export * from "./index?vue&type=script&lang=ts"

import "./UsersView.vue?vue&type=style&index=0&id=6080da04&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6080da04"]])

export default __exports__